import Vue from 'vue'
import EventBus from '@/helpers/eventBus'
import _ from 'lodash'
export default {
  name: 'AbmListado',
  props: {
    permiso: {
      type: String,
      required: true
    },
    modeloApi: {
      type: Object,
      required: true
    },
    referencia: {
      type: String,
      required: true
    }
  },
  data: () => ({
    montarMixin: true,
    filtros: {
      search: null
    },
    totalItems: 0,
    headers: [
      {
        text: 'ID',
        align: 'center',
        value: 'id'
      },
      { text: 'Acciones', value: 'name', sortable: false, align: 'center' }
    ],
    items: [],
    paginacion: {},
    itemsPorPagina: [20, 50, 100],
    cargando: false
  }),
  watch: {
    paginacion: {
      handler () {
        this.filtrarDatos()
      },
      deep: true
    }
  },
  created () {
    let vm = this
    EventBus.$on(this.referencia + ':filtrar', () => {
      if (vm.montarMixin) {
        vm.filtrar()
      }
    })
  },
  beforeDestroy () {
    EventBus.$off(this.referencia + ':filtrar')
  },
  methods: {
    puedo (operacion) {
      return this.$puedo(this.permiso + ':' + operacion)
    },
    filtrar () {
      let vm = this
      vm.filtros.page = 1
      vm.filtrarDatos()
    },

    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      vm.metodoFiltrar(_filtros).then(
        data => {
          Vue.set(vm, 'items', data.data)
          Vue.nextTick(() => {
            vm.totalItems = data.total

            this.$emit('alFiltrar')
            vm.cargando = false
          })
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },

    crear () {
      this.$emit('crearItem')
    },

    editar (item) {
      this.$emit('editarItem', item)
    },

    ver (item) {
      this.$emit('verItem', item)
    },

    mensajeEliminar (item) {
      return 'Desea eliminar el registro?'
    },

    eliminar (item) {
      let vm = this
      if (confirm(vm.mensajeEliminar(item))) {
        vm.cargando = true
        vm.modeloApi
          .eliminar(item.id)
          .then(() => {
            vm.mostrarMensajeOk()
            vm.cargando = false
            vm.filtrar()
          })
          .catch(error => {
            this.$emit('mostrarError', error)
            vm.cargando = false
          })
      }
    },

    mostrarMensajeOk () {
      Vue.notify({
        group: 'general',
        type: 'success',
        text: 'La operación finalizó correctamente!'
      })
    },

    metodoFiltrar (filtros) {
      return this.modeloApi.filtrar(filtros)
    },

    exportar (filtros) {
      let vm = this
      let _filtros = _.assign({}, vm.filtrosExportar())

      delete _filtros.page
      delete _filtros.perPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.metodoExportar(_filtros)
    },

    metodoExportar (filtros) {
      return this.modeloApi.exportar(filtros)
    },
    filtrosExportar () {
      let vm = this
      return vm.filtros
    }
  }
}
